/**
 * Predvoleny vzhlad prevadzky -- JEDINE miesto s fallbackmi. Kazdy branding
 * stlpec v companies (migracia 005) je nullable; NULL znamena "pouzi toto".
 *
 * Veteran mal doteraz text aj video natvrdo v HomePage.jsx. Jeho branding
 * (display_name, hero_title, hero_video_url) sa teraz nastavuje v DB --
 * inak by vyzeral ako ktorakolvek ina prevadzka.
 */
export const PLATFORM_NAME = "Rozvozy";

export const DEFAULT_BRANDING = {
  logo_url: "/rozvozy_icon.png",
  favicon_url: "/favicon.ico",
  hero_video_url: null,
  hero_image_url: null,
  hero_subtitle: null,
  primary_color: null, // null = farba z _variables.scss
  meta_description: "Rozvoz obedov a denného menu priamo k vašim dverám.",
};

/**
 * Zluci branding prevadzky s predvolenymi hodnotami a dopocita odvodene polia.
 * Pre root/platformu (tenant === null) vrati vzhlad platformy.
 */
export function brandingFor(tenant) {
  const b = (tenant && tenant.branding) || {};
  const displayName = b.display_name || tenant?.name || PLATFORM_NAME;
  const pick = (key) => b[key] || DEFAULT_BRANDING[key];

  return {
    displayName,
    logoUrl: pick("logo_url"),
    faviconUrl: pick("favicon_url"),
    heroVideoUrl: pick("hero_video_url"),
    heroImageUrl: pick("hero_image_url"),
    heroTitle: b.hero_title || `${displayName} – jedlo priamo k vašim dverám.`,
    heroSubtitle: pick("hero_subtitle"),
    primaryColor: pick("primary_color"),
    metaDescription: pick("meta_description"),
  };
}
